import { RootStore } from '../stores/index';
import { observable, action, computed } from 'mobx';
import { fromPromise, IPromiseBasedObservable, FULFILLED } from 'mobx-utils';
import { getOrganization, getOrganizations, createOrganization, updateOrganization } from '../api/organizationApi';
import OrganizationModel, { IOrganizationModel, IOrganizationsModel } from '../models/Organization';
import { object } from 'prop-types';
import { toJS } from 'mobx';

type ResponseDetails = {
  message : string
};

type Organization = {
  id : number,
  name : string,
  email : string,
  apiKey : string
}

class OrganizationStore {
  rootStore: RootStore;
  @observable organization : IOrganizationModel = {} as IOrganizationModel;
  @observable organizations : IOrganizationModel[] = [];
  @observable currentOrganizationId : number | null = null;
  @observable organizationDetailsRequest : IPromiseBasedObservable<IOrganizationsModel> | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @computed
  get currentOrganization() {
    const orgDetailsRequest = this.organizationDetailsRequest;
    if (orgDetailsRequest === null)
      return undefined;

    const { state, value } = orgDetailsRequest;
    if (state !== FULFILLED || value === null)
      return undefined;

    return OrganizationModel.create(value);
  }

  // @computed
  // get parentOrganizations() {
  //   return this.organizations.filter(org => org.childOrgsProp && org.childOrgsProp.length > 0);
  // }

  @action.bound
  getOrganizations() {
    getOrganizations().then(orgs => this.organizations = orgs.map((org : IOrganizationModel) => OrganizationModel.create(org)));
  }

  @action.bound
  createOrganization(org : IOrganizationModel, parentId : number | null, onSuccess: () => void) {
    createOrganization(org, parentId)
      .then(
        response => {
          if (response.ok) {
            response.json().then((value) => {
              
              this.organization = value;
              this.organizations.push(OrganizationModel.create(value));

              //TODO: parent not updating
              
            });
            onSuccess && onSuccess();
            console.log('orgs', this.organizations);
          }
        });
  }

  @action.bound
  setCurrentOrganization(id : number | null = null) {
    this.currentOrganizationId = id;
    if (id !== null)
      this.organizationDetailsRequest = fromPromise(getOrganization(id));
  }

  @action.bound
  updateOrganization(org : IOrganizationModel, parentId : number | null) {
    updateOrganization(org, parentId).then(response => {
      if (response.ok) {
        response.json().then((value) => {

          const updateOrg = OrganizationModel.create(value);
          const orgIndex = this.organizations.findIndex(x => x.id === org.id);
          
          this.organizations[orgIndex] = updateOrg;
        });
        
        this.rootStore.configurationStore.setAlert('Successfully Updated!', 'success');
        return;
      }
      response.json()
        .then(action((errorDetails: ResponseDetails | undefined) => {
          if (errorDetails === undefined || !errorDetails.message)
            return;

          this.rootStore.configurationStore.setAlert(
            `Oops! We were unable to process this request. \nError details:\n${errorDetails.message}`,
            'danger'
          );
          return;
        }));
    })
      .catch(console.error);
  }

}

export default OrganizationStore;